import React from "react"
import styled from "styled-components"

import { Icon } from "quorumdesign"

import { QuorumBlue } from "app/static/frontend/design-constants"

const LoadingRow = styled.div`
    display: flex;
    justify-content: center;
    padding: 20px;
    color: ${QuorumBlue};
`

const LoadingSpinner = () => (
    <LoadingRow>
        <Icon
            icon="spinner"
            size="4x"
            spin
        />
    </LoadingRow>
)

export default LoadingSpinner
